<template>
  <Card class="box-card">
    <Tabs v-model="helpPlanId">
      <TabPane :name="'' + item.id" :label="item.name" v-for="(item, index) in helpPlans" :key="index" class="tabs-style"></TabPane>
    </Tabs>
    <Tabs type="card" v-model="status">
      <TabPane :label="item.label" :name="'' + item.name" v-for="(item, index) in statusList" :key="index"></TabPane>
    </Tabs>
    <info :planId="helpPlanId" :status="status" />
  </Card>
</template>

<script>
import info from './info.vue';
export default {
  name: 'HelpManage',
  components: { info },
  data() {
    return {
      helpPlanId: '0',
      status: '1',
      helpPlans: [],
      statusList: [
        {
          label: '待处理',
          name: 1
        },
        {
          label: '已完成',
          name: 4
        },
        {
          label: '求职者确认',
          name: 5
        },
        {
          label: '取消报名申请',
          name: 2
        }
      ]
    };
  },
  created() {
    this.getHelpPlans();
  },
  methods: {
    getHelpPlans() {
      this.$axios
        .request({
          url: 'front/v1/help-plan',
          method: 'get'
        })
        .then(res => {
          this.helpPlans = res.data.list;
          if (this.helpPlans.length) {
            this.helpPlanId = this.helpPlans[0].id + '';
          }
        });
    }
  }
};
</script>
<style lang="less" scoped>
::v-deep .tabs-style .ivu-tabs-bar {
  margin-bottom: 0;
}
</style>
